import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { RouteConfigLoadEnd, RouteConfigLoadStart, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs/operators';

import { AuthService } from 'app/auth/auth.service';
import { Subscription } from 'rxjs';
import { ToastService } from './shared/toast/toast.service';
import { IdleService } from './utility/idle.service';

@Component({
  selector: 'apollo',
  imports: [RouterOutlet],
  host: {
    '(window:beforeunload)': 'beforeUnloadHander()'
  },
  template: `
    <router-outlet>
      <div class="initial-loader">
        <h4>Loading...</h4>
        <div class="loading-bars">
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </router-outlet>
  `
})
export class AppComponent implements OnInit, OnDestroy {
  private authService = inject(AuthService);
  private router = inject(Router);
  private toaster = inject(ToastService);
  private idleService = inject(IdleService);

  idleSubscription: Subscription;

  ngOnInit() {
    let asyncLoadCount = 0;
    this.router.events
      .pipe(
        filter(
          event => event instanceof RouteConfigLoadStart || event instanceof RouteConfigLoadEnd
        )
      )
      .subscribe(event => {
        if (event instanceof RouteConfigLoadStart) {
          asyncLoadCount++;
        } else if (event instanceof RouteConfigLoadEnd) {
          asyncLoadCount--;
        }

        if (!!asyncLoadCount) this.toaster.showLoading();
        else this.toaster.hideLoading();
      });

    const twoHoursInSeconds = 7200;
    this.idleSubscription = this.idleService
      .startWatching(twoHoursInSeconds)
      .subscribe(isTimedOut => {
        if (isTimedOut) {
          this.authService.sessionTimeout();
        }
      });
  }

  ngOnDestroy() {
    if (this.idleSubscription) this.idleSubscription.unsubscribe();
  }

  beforeUnloadHander() {
    if (this.authService.isImpersonating()) {
      this.authService.logout();
    }
  }
}
